import { DownloadFormatting, TranscriptFormat } from 'api/services/transcript';
import {
  MAX_CHARACTERS_PER_LINE_DEFAULT,
  SLICE_BY_CHAR_COUNT_UNSUPPORTED_EXPORT_FORMATS,
  SPEAKER_LABEL_FORMATTING_UNSUPPORTED_EXPORT_FORMATS,
  TIMESTAMPS_SUPPORTED_EXPORT_FORMATS,
  transcriptFormatList,
  YOUTUBE_FORMATTING_UNSUPPORTED_EXPORT_FORMATS,
} from './constants';

export function checkIsFileTypeUnsupportedForYouTubeFormatting(
  fileType: TranscriptFormat,
): boolean {
  return YOUTUBE_FORMATTING_UNSUPPORTED_EXPORT_FORMATS.includes(fileType);
}

export function checkIsFileTypeUnsupportedForSpeakerLabelFormatting(
  fileType: TranscriptFormat,
): boolean {
  return SPEAKER_LABEL_FORMATTING_UNSUPPORTED_EXPORT_FORMATS.includes(fileType);
}

export function checkIsFileTypeUnsupportedForSliceByCharCount(
  fileType: TranscriptFormat,
): boolean {
  return SLICE_BY_CHAR_COUNT_UNSUPPORTED_EXPORT_FORMATS.includes(fileType);
}

export function checkIsFileTypeSupportedForIncludeTimestamps(
  fileType: TranscriptFormat,
): boolean {
  return TIMESTAMPS_SUPPORTED_EXPORT_FORMATS.includes(fileType);
}

export function getTranscriptFormatLabelByValue(
  value: TranscriptFormat,
): string {
  const item = transcriptFormatList.find((format) => format.value === value);
  return item ? item.label : '';
}

export function getDownloadFormattingValues(
  newFormat: TranscriptFormat,
  currentDownloadFormatting: DownloadFormatting,
): DownloadFormatting {
  const { speakerFormat, sliceByCharCount, includeSpeakerLabels } =
    currentDownloadFormatting;

  let newSpeakerFormat = speakerFormat;
  let newIncludeSpeakerLabelsForAllSegments: boolean | undefined = false;
  let newSliceByCharCount: number | undefined = !sliceByCharCount
    ? MAX_CHARACTERS_PER_LINE_DEFAULT
    : sliceByCharCount;
  let newIncludeSpeakerLabels = includeSpeakerLabels;

  if (newFormat === 'vtt') {
    newSpeakerFormat = 'plain';
    newIncludeSpeakerLabelsForAllSegments = false;
    newSliceByCharCount = MAX_CHARACTERS_PER_LINE_DEFAULT;
    newIncludeSpeakerLabels = true;
  }

  if (newFormat === 'pdf' || newFormat === 'docx') {
    newSpeakerFormat = 'plain';
    newIncludeSpeakerLabelsForAllSegments = undefined;
    newSliceByCharCount = undefined;
  }

  return {
    ...currentDownloadFormatting,
    speakerFormat: newSpeakerFormat,
    includeSpeakerLabelsForAllSegments: newIncludeSpeakerLabelsForAllSegments,
    sliceByCharCount: newSliceByCharCount,
    includeSpeakerLabels: newIncludeSpeakerLabels,
  };
}
